/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsGrid_similarItems$ref: FragmentReference;
export type PdpRespSimilarItemsGrid_similarItems = $ReadOnlyArray<{|
  +serviceId: ?string,
  +categoryPath: ?string,
  +browseUrl: ?string,
  +categoryCode: ?string,
  +title: ?string,
  +ecommerceTrackingParams: ?any,
  +$fragmentRefs: PdpRespSimilarItem_item$ref,
  +$refType: PdpRespSimilarItemsGrid_similarItems$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGrid_similarItems",
  "type": "Item",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ecommerceTrackingParams",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3e38d2fe78be70542eea55c98de6aeb8';
module.exports = node;
